import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import Backend from "i18next-http-backend"
import { Locale } from "./types"

// It's important to explicitly load the namespaces that are used OUTSIDE OF REACT components,
// before the app initialization, otherwise the translations will not work correctly.
// In React components it works without explicit loading
// The namespaces of the two pages are here for another reason: there is no Suspense boundary
// above the routes, so a page waiting for its namespace would render nothing at all.
const INITIAL_NAMESPACES = ["common", "auth", "export"]

const initI18n = async () => {
  return i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      ns: INITIAL_NAMESPACES,
      defaultNS: "common",
      fallbackLng: Locale.EN,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
    })
}

const { t } = i18n

export { initI18n, t }
export default i18n
